import { useQuery } from 'react-query';
import { getUsersWithAvatars } from 'resources/user/workflows';

export default function useGetCompanyUsers(companyId, queryOptions) {
  return useQuery(
    ['users.companyUsers', companyId],
    () => getUsersWithAvatars(),
    queryOptions,
  );
}
